import React from "react";
import { FormSection } from "components/ratecard/_common";
import EditInline from "./EditInline";
import Preview from "./Preview";
import { useEditServiceContext, useRateCardContext } from "components/ratecard/contextProviders";
import { getCurrencyByCountry } from "helperFunctions/_common/getCurrencyByCountry";

const SameDayPostageFeeSection = () => {
  const name = "sameDayPostageFee";
  const { allowEditing } = useEditServiceContext();
  const { activeZone } = useRateCardContext();

  const currency: string = getCurrencyByCountry(activeZone?.facility?.country || "");

  return (
    <FormSection title="Same Day Postage Fee">
      {allowEditing ? <EditInline name={name} currency={currency} /> : <Preview name={name} currency={currency} />}
    </FormSection>
  );
};

export default SameDayPostageFeeSection;
